<template>
  <div>
    <v-dialog width="700px" v-if="show" v-model="show" persistent>
      <v-card class="pa-4">
        <v-flex class="row mx-3 my-2">
          <v-layout align-center>
            <span class="title font-weight-medium">Informações da Reserva</span>
            <v-spacer></v-spacer>
            <v-btn icon class="ma-0" @click="show=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex class="row mx-3 my-2">
          <v-layout align-center>
            <v-flex sm6>
              <v-text-field label="Usuário" v-model="vehicleRequest.user.name" disabled></v-text-field>
              <v-text-field label="Status" v-model="vehicleRequest.step.title" disabled></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field label="Telefone" v-model="vehicleRequest.user.phone" disabled></v-text-field>
              <v-text-field label="Placa" v-model="vehicleRequest.vehicle.plate" disabled></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card>
    </v-dialog>

    <v-card width="100%">
      <v-card-title class="pa-6 calendar">
        <span class="mx-auto font-weight-bold white--text">
          <v-icon dark>event</v-icon>
        </span>
      </v-card-title>
      <v-layout>
        <v-flex>
          <v-sheet height="600">
            <!-- now is normally calculated by itself, but to keep the calendar in this date range to view events -->
            <v-calendar
              ref="calendar"
              color="primary"
              :events="events"
              type="week"
              :now="today"
              :value="today"
              locale="pt-br"
              @click:event="open" />
          </v-sheet>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import VehicleRequestController from "../../controllers/VehicleRequestController";
import moment from "moment";
import "moment-precise-range-plugin";
export default {
  data() {
    return {
      vehicleRequestController: new VehicleRequestController(this.$resource),
      show: false,
      today: moment(new Date()).format("YYYY-MM-DD"),
      events: [],
      vehicleRequest: {},
    };
  },
  computed: {
    eventsMap() {
      const map = {};
      this.events.forEach((e) => (map[e.date] = map[e.date] || []).push(e));
      return map;
    },
  },
  props: {
    clientId: {
      required: false,
      type: Number,
    },
  },
  mounted() {
    this.$refs.calendar.scrollToTime("08:00");
  },
  created() {
    this.getEventsByClientId();
  },
  methods: {
    open({ nativeEvent, event }) {
      this.show = true;
      this.vehicleRequest = event.reserva;
    },
    getEventsByClientId(clientId) {
      this.vehicleRequestController
        .getVehicleRequestByClientId(this.clientId)
        .then((res) => {
          res.map((item) => {
            const startDate =  moment(item.begin_date).format("YYYY-MM-DD HH:mm");
            const endDate =  moment(item.end_date).format("YYYY-MM-DD HH:mm");
            this.events.push({
              name: `${item.vehicle.vehicle_model.model} - ${item.vehicle.plate}`,
              start: startDate,
              end: endDate,
              reserva: item,
            });
          });
        });
    },
    durationConvert(duration) {
      let minutes = 0;
      if (duration.hours) {
        minutes += duration.hours * 60;
      }
      if (duration.minutes) {
        minutes += duration.minutes;
      }
      return minutes;
    },
  },
};
</script>
<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;

  &.with-time {
    position: absolute;
    right: 4px;
    margin-right: 0px;
  }
}

.calendar {
  background-color: var(--primary-color);
}
</style>
